import * as React from 'react';
import {ColumnProps} from 'antd/lib/table';
import {ErrorResponse, MaintenanceTodoEntry, MaintenanceTodos, SaveItemAlertRequest} from '../api/dtos/dtos';
import locales from '../locales';
import {Button, Modal, Table} from 'antd';
import {ErrorAlert} from '../common/ErrorAlert';
import * as tableUtils from '../utils/table-utils';
import {simpleColumn} from '../utils/table-utils';
import {
  ApplicationContextConsumer,
  bindLoadingHandler,
  LoadingOverlayHandler,
  withLoadingOverlay
} from '../app/ApplicationContext';
import furoApi from '../api/FuroApi';
import {showSaveSuccessNotification} from '../utils/dialogs';
import SectionHeaderFormItem from "../common/form-items/SectionHeaderFormItem";
import ButtonBar from "../common/ButtonBar";
import MaintenanceTodoForm from "./MaintenanceTodoForm";

interface Props {
  itemId: number;
}

interface ItemMaintenanceSheetEditorState {
  editing: boolean;
  editedAlert?: SaveItemAlertRequest;
  todos?: MaintenanceTodos;
  error?: ErrorResponse;
}

class MaintenanceTodoEditor extends React.Component<Props, ItemMaintenanceSheetEditorState> {

  public readonly loadingHandler?: LoadingOverlayHandler;

  public state: ItemMaintenanceSheetEditorState = {
    editing: false,
  };

  public componentDidMount() {
    this.reload();
  }

  public render(): React.ReactNode {
    const {todos, editing, error} = this.state;
    const data = todos ? todos.entries : [];

    const columns: Array<ColumnProps<MaintenanceTodoEntry>> = [
      simpleColumn(locales.comment, this.renderCommentRow),
    ];

    return (
      <>
        <ApplicationContextConsumer>
          {({loadingHandler}) => bindLoadingHandler(loadingHandler, this)}
        </ApplicationContextConsumer>

        <Modal
          title={locales.reminders}
          visible={editing}
          footer={null}
          onCancel={this.onFormCancel}
          destroyOnClose={true}
        >
          <MaintenanceTodoForm
            entries={data}
            onFormSubmit={this.onFormSubmit}
            onFormCancel={this.onFormCancel}
          />
        </Modal>

        <SectionHeaderFormItem title={locales.reminders} style={{marginTop: 24}}/>

        <ButtonBar style={{marginBottom: 8}}>
          <Button icon="edit" size="small" type="primary" onClick={this.onEditClick}>{locales.edit}</Button>
        </ButtonBar>

        <Table
          dataSource={data}
          columns={columns}
          rowKey={tableUtils.indexRowKeyFn}
          bordered={true}
          showHeader={false}
          pagination={false}
          size="small"
          scroll={{x: 512}}
        />

        <ErrorAlert style={{marginTop: '16px'}} error={error}/>
      </>
    );
  }

  private onEditClick = () => {
    this.setState({editing: true});
  };

  private onFormCancel = () => {
    this.setState({editing: false});
  };

  private onFormSubmit = (todos: MaintenanceTodos) => {
    const {itemId} = this.props;
    withLoadingOverlay(
      furoApi.items.saveMaintenanceTodos(itemId, todos)
        .then(this.onSaveSuccess)
        .catch(this.onApiError), this.loadingHandler);
  };

  private onSaveSuccess = () => {
    this.onFormCancel();
    showSaveSuccessNotification();
    this.reload();
  };

  private onApiError = (error: ErrorResponse) => {
    this.setState({error});
  };

  private reload = () => {
    const {itemId} = this.props;
    withLoadingOverlay(
      furoApi.items.getMaintenanceTodos(itemId)
        .then(this.onReloadSuccess)
        .catch(this.onApiError), this.loadingHandler);
  };

  private onReloadSuccess = (todos: MaintenanceTodos) => {
    this.setState({
      todos,
      error: undefined,
    });
  };

  private renderCommentRow = (entry: MaintenanceTodoEntry) => {
    const style: React.CSSProperties = entry.checked ? {textDecoration: 'line-through'} : {};
    return (
      <span style={style}>{entry.comment}</span>
    );
  }
}

export default MaintenanceTodoEditor;


// WEBPACK FOOTER //
// ./src/item-details/MaintenanceTodoEditor.tsx